export default [
    {
        path: '/flight',
        props: true,
        component: () => import('@/views/Flight'),
    },
    {
        path: '/flight/:id',
        props: true,
        component: () => import('@/views/Flight/Show'),
    },
];
